import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  IDispositivoLuminariaACTIS,
  IDispositivoLuminariaGPE,
  IFilter,
  IPopulate,
  IQueryParam,
} from 'modelos/src';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { IDispositivoLorawan, ILuminaria } from 'modelos/src';
import { DispositivosLorawanService } from '../dispositivos-lorawan.service';
import { LuminariasHttpService } from '../../../../../auxiliares/servicios/http/luminarias.service';
import { FormularioDialogService } from '../../../../../auxiliares/servicios/formulario-dialog.service';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../auxiliares/tabla/filtro/filtro.component';
import {
  IColumnas,
  ICrearBoton,
  IExportarBoton,
} from '../../../../../auxiliares/tabla/tabla.component';
import { FilaNSDialogComponent } from '../filas-ns/fila-ns-dialog.component';
import { FilasNSPanelComponent } from '../filas-ns/filas-ns-panel.component';
import { LoginService } from '../../../../login/login.service';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { LuminariasService } from '../../../luminarias/service';
import { ClienteJerarquiaService } from '../../../../../auxiliares/servicios/cliente-jerarquia.service';
import { CambiarClienteComponent } from '../../../../standalone/cambiar-cliente/cambiar-cliente.component';
import { escaparHtml } from '../../../../../auxiliares/html-seguro.util';
import {
  estadoConexionCelda,
  estadoHtml,
  fechaCelda,
  haceCelda,
} from '../../../../../auxiliares/tabla/celdas';
import {
  IEstadoCelda,
  TonoEstado,
} from '../../../../../auxiliares/tabla/tabla.interfaces';
import {
  estadoConexion,
  minutosDesde,
} from '../../../../../auxiliares/estado-conexion.util';

/** Estado de un comando (downlink) con el nombre en castellano y su tono.
 *  «No Recibido» es ack false: no es falla dura, va en aviso. */
export function estadoComandoCelda(estado?: string): IEstadoCelda {
  switch (estado) {
    case 'Ejecutado':
      return { texto: 'Ejecutado', tono: 'ok', icono: 'check_circle' };
    case 'Recibido':
      return { texto: 'Recibido', tono: 'ok', icono: 'check_circle' };
    case 'No Ejecutado':
      return { texto: 'No ejecutado', tono: 'error', icono: 'cancel' };
    case 'No Recibido':
      return { texto: 'No recibido', tono: 'aviso', icono: 'cancel' };
    case 'Descartado':
      return { texto: 'Descartado', tono: 'neutro', icono: 'block' };
    case 'En Cola':
      return { texto: 'En fila', tono: 'info', icono: 'pending' };
    default:
      return { texto: estado || 'Pendiente', tono: 'info', icono: 'pending' };
  }
}

@Component({
  selector: 'app-dispositivoslorawan',
  templateUrl: './dispositivos-lorawan.component.html',
  standalone: false,
})
export class DispositivosLorawanComponent implements OnInit, OnDestroy {
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private formularios = inject(FormularioDialogService);
  private service = inject(DispositivosLorawanService);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);
  private luminariasService = inject(LuminariasService);
  private luminariasHttp = inject(LuminariasHttpService);
  private clienteJerarquia = inject(ClienteJerarquiaService);

  public clientePropio = LoginService.getCliente();

  // Mapa deveui(UPPER) → luminaria asignada a ese dispositivo. La relación es
  // por deveui (luminaria.deveui == dispositivo.deveui); el device no tiene
  // virtual inverso, así que se resuelve con un fetch secundario en `listar`.
  private luminariasPorDeveui: Record<string, ILuminaria> = {};

  //// Tabla nueva
  public name = 'DispositivosLorawanComponent';
  public dispositivoslorawan: IDispositivoLorawan[] = [];
  public dispositivosLorawan$?: Subscription;
  public totalCount = 0;
  public columnas?: IColumnas<IDispositivoLorawan>[];

  public botonCrear: ICrearBoton = {
    mostrar: this.helper.tienePermiso(
      'Administración - Crear dispositivos Lorawan',
    ),
    tooltip: 'Crear dispositivo LoRaWAN',
    color: 'primary',
    tipo: 'material',
    icon: 'add',
    accion: () => this.crear(),

    //Buscar
  };

  // Acción de cabecera: PANEL GENERAL de filas del NS (todos los dispositivos).
  // Va por el input `exportar` de la tabla, que es la lista genérica de botones
  // de cabecera (no hay otro slot); no exporta nada.
  //
  // Sólo nivel 0: es estado interno del network server y sus botones borran
  // downlinks. El backend lo exige igual con el Nivel0Guard.
  public botonesHeader: IExportarBoton[] = [
    {
      mostrar: this.helper.esNivel0(),
      tooltip: 'Filas de downlinks en el network server (todos)',
      tipo: 'material',
      icon: 'playlist_remove',
      accion: () => this.abrirPanelFilasNS(),
    },
  ];
  public search: IRegExpSearch = {
    fields: ['name', 'deveui'],
  };

  public populate: IPopulate[] = [
    {
      path: 'cliente',
      select: 'nombre',
    },
    {
      path: 'modeloDispositivo',
      populate: {
        path: 'codigos',
        populate: {
          path: 'codigos.categoriaEvento',
        },
      },
    },
  ];

  // FILTROS
  // Cliente propietario (dueño del dispositivo)
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
    // filtroSelector: ['moduloDispositivosLorawan'],
  };
  // Cliente en cuya jerarquía cuelga el dispositivo (incluye descendientes)
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
    // filtroSelector: ['moduloDispositivosLorawan'],
  };

  // Modelo. Usa el selector estándar de modelos (mismo que el crear/editar del
  // dispositivo): acota por tipo 'DispositivoLorawan', muestra "marca - modelo"
  // y respeta el scope de cliente (no trae modelos de otros clientes).
  public modelo: IFiltroTabla = {
    filter: {
      field: 'idModeloDispositivo',
    },
    label: 'Modelo',
    tipo: 'modelo-dispositivo-selector',
    tipoDispositivo: 'DispositivoLorawan',
  };
  // Tipo dispositivo
  public tipo: IFiltroTabla = {
    elementos: [
      'Luminaria GPE',
      'Luminaria Wellness',
      'Luminaria ACTIS FING',
      'Luminaria CitiLight',
    ],
    filter: {
      field: 'tipo',
    },
    label: 'Tipo',
    tipo: 'ngselect',
  };

  private now = new Date();

  // Última comunicación (buckets sobre fechaUltimaComunicacion)
  public fechaUltimaComunicacion: IFiltroTabla = {
    elementos: [
      {
        label: 'Últimas 24 horas',
        value: [
          {
            fechaUltimaComunicacion: {
              $gte: new Date(
                this.now.getTime() - 24 * 60 * 60 * 1000,
              ).toISOString(),
            },
          },
        ],
      },
      {
        label: 'Más de 1 día',
        value: [
          {
            fechaUltimaComunicacion: {
              $lt: new Date(
                this.now.getTime() - 24 * 60 * 60 * 1000,
              ).toISOString(),
            },
          },
        ],
      },
      {
        label: 'Más de 2 días',
        value: [
          {
            fechaUltimaComunicacion: {
              $lt: new Date(
                this.now.getTime() - 2 * 24 * 60 * 60 * 1000,
              ).toISOString(),
            },
          },
        ],
      },
      {
        label: 'Más de 1 semana',
        value: [
          {
            fechaUltimaComunicacion: {
              $lt: new Date(
                this.now.getTime() - 7 * 24 * 60 * 60 * 1000,
              ).toISOString(),
            },
          },
        ],
      },
      {
        label: 'Más de 1 mes',
        value: [
          {
            fechaUltimaComunicacion: {
              $lt: (() => {
                const d = new Date(this.now);
                d.setMonth(d.getMonth() - 1);
                return d.toISOString();
              })(),
            },
          },
        ],
      },
    ],
    filter: {
      field: '$or',
    },
    label: 'Última comunicación',
    selectLabel: 'label',
    selectValue: 'value',
    tipo: 'select',
  };

  // Tasa de entrega (buckets sobre paquetes.perdidaPaquetes; tasa = 100 - pérdida)
  public tasaEntrega: IFiltroTabla = {
    elementos: [
      {
        label: 'Excelente (≥ 95%)',
        filter: [{ 'paquetes.perdidaPaquetes': { $lt: 5 } }],
      },
      {
        label: 'Aceptable (80% – 95%)',
        filter: [{ 'paquetes.perdidaPaquetes': { $gte: 5, $lt: 20 } }],
      },
      {
        label: 'Crítico (< 80%)',
        filter: [{ 'paquetes.perdidaPaquetes': { $gte: 20 } }],
      },
    ],
    filter: {
      field: '$or',
    },
    label: 'Tasa de entrega',
    rapido: true,
    tipo: 'ngselect',
    selectLabel: 'label',
    selectValue: 'filter',
  };

  // Estado en Network Server (habilitado/deshabilitado)
  public estadoNetworkServer: IFiltroTabla = {
    elementos: [
      {
        label: 'Habilitado',
        icon: 'check',
        iconColor: 'var(--color-green-text)',
        filter: [{ isDisabled: { $ne: true } }],
      },
      {
        label: 'Deshabilitado',
        icon: 'block',
        iconColor: 'var(--color-red-text)',
        filter: [{ isDisabled: true }],
      },
    ],
    filter: {
      field: '$or',
    },
    label: 'Estado (Network Server)',
    rapido: true,
    rapidoLabel: 'Network Server',
    tipo: 'ngselect',
    selectIcon: true,
    selectLabel: 'label',
    selectValue: 'filter',
  };

  public filtros: IFiltroTabla[] = [
    this.tipo,
    this.modelo,
    this.fechaUltimaComunicacion,
    this.tasaEntrega,
    this.estadoNetworkServer,
  ];

  //Query
  public filter: IFilter<IDispositivoLorawan> = {};
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    sort: 'name',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };

  //Listar
  public async listar(): Promise<void> {
    this.dispositivosLorawan$?.unsubscribe();
    this.dispositivosLorawan$ = this.lista2
      .dispositivosLorawans(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.dispositivoslorawan = data.datos;
        void this.cargarAsignaciones(data.datos);
      });
  }

  // Resuelve la luminaria asignada a cada dispositivo de la página actual
  // (match por deveui). Un fetch por página, no por fila.
  private async cargarAsignaciones(
    dispositivos: IDispositivoLorawan[],
  ): Promise<void> {
    this.luminariasPorDeveui = {};
    const deveuis = dispositivos
      .map((d) => d.deveui)
      .filter((d): d is string => !!d);
    if (!deveuis.length) return;
    try {
      const res = await this.luminariasHttp.getFiltered({
        filter: JSON.stringify({ deveui: { $in: deveuis } }),
        select: 'identificacion deveui idPuesta idCliente',
        populate: JSON.stringify([
          { path: 'puesta', select: 'identificacion' },
        ]),
        limit: deveuis.length,
        includeChildren: true,
      });
      const mapa: Record<string, ILuminaria> = {};
      for (const lum of res.datos) {
        if (lum.deveui) mapa[lum.deveui.toUpperCase()] = lum;
      }
      this.luminariasPorDeveui = mapa;
    } catch (error) {
      console.error('Error cargando asignaciones de luminarias', error);
    }
  }

  private luminariaDe(dato: IDispositivoLorawan): ILuminaria | undefined {
    return dato.deveui
      ? this.luminariasPorDeveui[dato.deveui.toUpperCase()]
      : undefined;
  }

  // Acciones
  public async crear() {
    this.navigator.navigate(['crear'], { relativeTo: this.route });
  }

  public async crearChirpstack(dispositivolorawan: IDispositivoLorawan) {
    const res = await this.dialogService.confirm(
      'Crear',
      `¿Querés crear el dispositivo ${dispositivolorawan.name} en NetworkServer?`,
    );
    if (!res) return;
    try {
      await this.service.createChirpstack(dispositivolorawan);
      this.helper.notifSuccess('Dispositivo Lorawan creado en Network Server');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public async editar(dispositivolorawan: IDispositivoLorawan) {
    this.navigator.navigate(['editar', dispositivolorawan._id], {
      relativeTo: this.route,
    });
  }

  // Fila del NS de UN dispositivo, en diálogo (misma vista que la solapa del
  // detalle). Nivel 0.
  public verFilaNS(dispositivolorawan: IDispositivoLorawan): void {
    this.formularios.abrir(FilaNSDialogComponent, {
      tamano: 'mediano',
      cerrarAfuera: true,
      data: {
        idDispositivo: dispositivolorawan._id,
        nombre: dispositivolorawan.name || dispositivolorawan.deveui,
      },
    });
  }

  // Panel general: escanea las filas del NS de todo el parque clase B/C.
  //
  // Importa que sea general y no sólo por dispositivo: la tasa de error del
  // scheduler de Chirpstack mide NODOS, no items, así que con un solo nodo
  // sucio el bucle sigue. Para cortarlo hay que ver quiénes son y vaciarlos
  // todos.
  public abrirPanelFilasNS(): void {
    this.formularios.abrir(FilasNSPanelComponent, {
      tamano: 'grande',
      cerrarAfuera: true,
    });
  }

  // Mueve sólo el dispositivo. Si su luminaria queda en otro cliente, el
  // backend la desasigna (el diálogo lo avisa).
  public cambiarCliente(dispositivolorawan: IDispositivoLorawan): void {
    const dialogRef = this.formularios.abrir(CambiarClienteComponent, {
      tamano: 'mediano',
      data: {
        entidad: dispositivolorawan,
        tipoEntidad: 'Dispositivo Lorawan',
        luminaria: this.luminariaDe(dispositivolorawan),
      },
    });
    dialogRef.afterClosed().subscribe(async (resultado) => {
      if (resultado) {
        await this.listar();
      }
    });
  }

  public async verDetalle(dispositivolorawan: IDispositivoLorawan) {
    this.navigator.navigate(['detalles', dispositivolorawan._id], {
      relativeTo: this.route,
    });
  }

  public async eliminar(dispositivolorawan: IDispositivoLorawan) {
    const res = await this.dialogService.confirm(
      'Eliminar',
      `¿Querés eliminar el dispositivo ${dispositivolorawan.name}?`,
      'Aceptar',
      'Cancelar',
      true,
      'Eliminar también en LoRaWAN Server',
      true,
    );
    if (!res.confirmed) return;
    try {
      await this.service.deleteById(dispositivolorawan._id!, res.checkbox);
      this.helper.notifSuccess('Dispositivo Lorawan eliminado');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public async eliminarChirpstack(dispositivolorawan: IDispositivoLorawan) {
    const res = await this.dialogService.confirm(
      'Eliminar',
      `¿Querés eliminar el dispositivo ${dispositivolorawan.name} en NetworkServer?`,
    );
    if (!res) return;
    try {
      await this.service.deleteChirpstack(dispositivolorawan._id!);
      this.helper.notifSuccess(
        'Dispositivo Lorawan eliminado de Network Server',
      );
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public async consultarDeviceChirpstack(
    dispositivolorawan: IDispositivoLorawan,
  ) {
    const res = await this.dialogService.confirm(
      'Consultar',
      `¿Querés consultar si existe el dispositivo ${dispositivolorawan.name} en Network Server? `,
    );
    if (!res) return;
    try {
      const deviceEncontrado = await this.service.consultarChirpstack(
        dispositivolorawan?._id,
      );

      if (deviceEncontrado) {
        this.helper.notifSuccess('Dispositivo encontrado en Network Server');
      } else {
        this.helper.notifError('Dispositivo no encontrado en Network Server');
      }

      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  /** Dato con su ícono de entidad (clase común de la tabla). */
  private linea(texto: string, icono: string, clase = ''): string {
    return `<div class="tabla-linea"><span class="material-symbols-outlined">${icono}</span><span class="${clase}">${texto}</span></div>`;
  }

  /** Tasa de entrega (100 − pérdida) con un decimal sólo si lo tiene. */
  private tasaDe(dato: IDispositivoLorawan): number | undefined {
    const perdida = dato.paquetes?.perdidaPaquetes;
    if (perdida == null) return undefined;
    return 100 - perdida;
  }

  private formatoTasa(tasa: number): string {
    return `${tasa.toLocaleString('es-AR', { maximumFractionDigits: 1 })} %`;
  }

  private setColumnas() {
    const columnas: IColumnas<IDispositivoLorawan>[] = [
      // Dispositivo (Nombre + modelo + tipo + DevEUI + JoinEUI)
      {
        header: {
          label: 'Dispositivo',
          sort: 'name',
          sortable: true,
        },
        row: {
          html: (dato) => {
            const nombre = dato?.name ?? '';
            const deveui = dato?.deveui ?? '';
            const joineui = dato?.joineui ?? '';
            const tipo = dato?.tipo ?? '';

            let html = `<div class="tabla-celda-col">`;

            if (nombre) {
              html += this.linea(escaparHtml(nombre), 'router', 'tabla-principal');
            }
            // Modelo (marca/modelo) del modeloDispositivo, junto a la
            // identificación — misma estética que el listado de luminarias.
            const marca = dato?.modeloDispositivo?.marca || '';
            const modelo = dato?.modeloDispositivo?.modelo || '';
            if (marca || modelo) {
              html += this.linea(
                `${escaparHtml(marca)} ${escaparHtml(modelo)}`,
                'memory',
              );
            } else {
              html += `<span>${estadoHtml({ texto: 'Sin modelo asignado', tono: 'aviso', icono: 'warning' })}</span>`;
            }
            if (tipo) {
              html += this.linea(escaparHtml(tipo), 'category');
            }
            if (deveui) {
              html += this.linea(escaparHtml(deveui), 'fingerprint', 'tabla-codigo');
            }
            // JoinEUI solo si difiere del DevEUI (comparación case-insensitive).
            if (joineui && joineui.toLowerCase() !== deveui.toLowerCase()) {
              html += this.linea(escaparHtml(joineui), 'fingerprint', 'tabla-codigo');
            }

            html += `</div>`;
            return html;
          },
          tooltip: (dato) => {
            const items: string[] = [];
            if (dato?.name)
              items.push(
                `<div>Nombre: <strong>${escaparHtml(dato.name)}</strong></div>`,
              );
            if (
              dato?.modeloDispositivo?.marca ||
              dato?.modeloDispositivo?.modelo
            )
              items.push(
                `<div>Modelo: <strong>${escaparHtml(dato.modeloDispositivo?.marca ?? '')} ${escaparHtml(dato.modeloDispositivo?.modelo ?? '')}</strong></div>`,
              );
            if (dato?.deveui)
              items.push(
                `<div>DevEUI: <strong>${escaparHtml(dato.deveui)}</strong></div>`,
              );
            if (
              dato?.joineui &&
              dato?.joineui.toLowerCase() !== dato?.deveui?.toLowerCase()
            )
              items.push(
                `<div>JoinEUI: <strong>${escaparHtml(dato.joineui)}</strong></div>`,
              );
            if (dato?.tipo)
              items.push(
                `<div>Tipo: <strong>${escaparHtml(dato.tipo)}</strong></div>`,
              );
            return items.length > 0 ? items.join('') : undefined;
          },
          noData: 'Sin datos del dispositivo',
        },
      },
      // Conectividad: comunicación con el criterio de los detalles (si hay
      // frecuencia de reporte), señal, frec. reporte y lím. comunicación
      {
        header: {
          label: 'Conectividad',
          sort: 'fechaUltimaComunicacion',
          sortable: true,
        },
        row: {
          html: (dato) => {
            let html = `<div class="tabla-celda-col">`;
            const fecha = dato?.fechaUltimaComunicacion;
            const frec = this.getFrecuenciaReporte(dato);

            // Comunicación: estado sólo si hay frecuencia contra qué medir
            if (!fecha || frec != null) {
              html += `<span>${estadoHtml(estadoConexionCelda(fecha, frec ?? undefined))}</span>`;
            }
            if (fecha) {
              html += `<span class="tabla-secundario">${fechaCelda(fecha)} · ${haceCelda(fecha)}</span>`;
            }

            // Señal (en gris si el equipo no está reportando)
            const vigente =
              !!fecha &&
              (frec == null ||
                estadoConexion(minutosDesde(fecha), frec).tono !== 'apagado');
            const senialHtml = this.luminariasService.htmlSenial(dato, vigente);
            if (senialHtml) {
              html += `<div class="tabla-celda-fila">${senialHtml}</div>`;
            }

            // Frec. reporte
            if (frec != null) {
              html += `<span class="tabla-secundario">Frec. reporte: <strong>${frec} min</strong></span>`;
            }

            // Tiempo límite comunicación
            const lim = dato?.tiempoLimiteComunicacion;
            if (lim != null) {
              html += `<span class="tabla-secundario">Lím. comunicación: <strong>${lim} h</strong></span>`;
            }

            html += `</div>`;
            return html;
          },
          tooltip: (dato) => {
            const items: string[] = [];
            if (dato?.fechaUltimaComunicacion) {
              items.push(
                `<div>Última comunicación: <strong>${fechaCelda(dato.fechaUltimaComunicacion)}</strong></div>`,
              );
              if (this.getFrecuenciaReporte(dato) == null)
                items.push('<div>No hay frecuencia de reporte</div>');
            }
            const level = dato?.margin;
            if (level != null) {
              items.push(
                `<div>Señal: <strong>${Math.round(level)} dB</strong></div>`,
              );
            }
            return items.length > 0 ? items.join('') : undefined;
          },
          noData: 'Sin datos de conectividad',
        },
      },
      // Tasa de entrega
      {
        header: {
          label: 'Tasa de entrega',
          sortable: true,
          sort: 'paquetes.perdidaPaquetes',
        },
        row: {
          estado: (dato) => {
            const tasa = this.tasaDe(dato);
            if (tasa == null) return undefined;
            const framesRecibidos = dato.paquetes?.framesRecibidos || 0;
            const fCntActual = dato.paquetes?.ultimoFcnt || 0;
            const fCntInicial = dato.paquetes?.fCntInicial || 0;
            // Frames esperados con la misma fórmula del backend
            const framesEsperados = fCntActual - fCntInicial + 1;
            const [nombre, tono, icono]: [string, TonoEstado, string] =
              tasa >= 95
                ? ['Excelente', 'ok', 'check_circle']
                : tasa >= 80
                  ? ['Aceptable', 'aviso', 'warning']
                  : ['Crítico', 'error', 'error'];
            return {
              texto: this.formatoTasa(tasa),
              tono,
              icono,
              detalle: nombre,
              tooltip: `${nombre}: ${this.formatoTasa(tasa)} entregados (${framesRecibidos.toLocaleString('es-AR')} recibidos, ${framesEsperados.toLocaleString('es-AR')} esperados)`,
            };
          },
          noData: 'Sin datos de entrega',
        },
      },
      // Asignado a (luminaria — y su puesta si tiene). Relación por deveui,
      // resuelta en `cargarAsignaciones`.
      {
        header: {
          label: 'Asignado a',
        },
        row: {
          html: (dato) => {
            const lum = this.luminariaDe(dato);
            if (!lum) return '';
            let html = `<div class="tabla-celda-col">`;
            html += this.linea(
              escaparHtml(lum.identificacion || lum.deveui || 'Luminaria'),
              'lightbulb',
              'tabla-principal',
            );
            if (lum.puesta?.identificacion) {
              html += this.linea(
                escaparHtml(lum.puesta.identificacion),
                'table_lamp',
              );
            }
            html += `</div>`;
            return html;
          },
          tooltip: (dato) => {
            const lum = this.luminariaDe(dato);
            if (!lum)
              return 'Este dispositivo no está asignado a ninguna luminaria';
            const items: string[] = [
              `<div>Luminaria: <strong>${escaparHtml(lum.identificacion || lum.deveui)}</strong></div>`,
            ];
            if (lum.puesta?.identificacion)
              items.push(
                `<div>Puesta: <strong>${escaparHtml(lum.puesta.identificacion)}</strong></div>`,
              );
            return items.join('');
          },
          noData: 'Sin luminaria asignada',
        },
      },
      // Último comando (downlink) enviado al dispositivo.
      {
        header: {
          label: 'Último comando',
        },
        row: {
          html: (dato) => {
            const comando = dato?.ultimoComando;
            if (!comando) return '';

            let inner = `<span>${estadoHtml(estadoComandoCelda(comando.estado))}</span>`;
            if (comando.descripcion) {
              inner += `<span>${escaparHtml(comando.descripcion)}</span>`;
            }
            const fecha = comando.fechaActualizacion || comando.fechaCreacion;
            if (fecha) {
              inner += `<span class="tabla-secundario">${fechaCelda(fecha)} · ${haceCelda(fecha)}</span>`;
            }
            return `<div class="tabla-celda-col">${inner}</div>`;
          },
          tooltip: (dato) => {
            const comando = dato?.ultimoComando;
            if (!comando) return undefined;
            const items: string[] = [];
            if (comando.descripcion)
              items.push(`<div>${escaparHtml(comando.descripcion)}</div>`);
            if (comando.estado)
              items.push(
                `<div>Estado: <strong>${escaparHtml(estadoComandoCelda(comando.estado).texto)}</strong></div>`,
              );
            if (comando.estado === 'Descartado')
              items.push(`<div>Dispositivo sin comunicación al momento de enviar</div>`);
            if (comando.objetivo?.nombre)
              items.push(
                `<div>Origen: <strong>${escaparHtml(comando.objetivo.nivel)}</strong> · ${escaparHtml(comando.objetivo.nombre)}</div>`,
              );
            return items.length > 0 ? items.join('') : undefined;
          },
          noData: 'Sin comandos',
        },
      },
    ];

    // Cliente. Se muestra además la jerarquía de clientes en un tooltip: con
    // varios clientes de nombre parecido el nombre solo no alcanza para saber
    // de quién cuelga el dispositivo.
    if (HelperService.getTipoCliente() !== 'Final') {
      columnas.push({
        header: {
          label: 'Cliente',
        },
        row: {
          html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
          tooltip: (dato) =>
            this.clienteJerarquia.tooltipJerarquia(dato.cliente),
          noData: 'Sin cliente',
        },
      });
    }
    // Acciones (agrupadas en un menú overflow). Las operaciones contra el
    // Network Server (ChirpStack) van en un submenú para no saturar la fila.
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        accionesGrouped: [
          {
            tipo: 'material',
            icon: 'visibility',
            tooltip: 'Ver detalle',
            click: (dato) => this.verDetalle(dato),
          },
          {
            tipo: 'material',
            icon: 'playlist_remove',
            tooltip: 'Fila de downlinks (NS)',
            click: (dato) => this.verFilaNS(dato),
            // Sólo nivel 0: muestra el estado interno del network server y deja
            // vaciarlo. El backend lo exige igual (Nivel0Guard).
            oculta: () => !this.helper.esNivel0(),
          },
          {
            tipo: 'material',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: () =>
              !this.helper.tienePermiso(
                'Administración - Editar dispositivos Lorawan',
              ),
          },
          {
            tipo: 'material',
            icon: 'drive_file_move',
            tooltip: 'Cambiar de cliente',
            click: (dato) => this.cambiarCliente(dato),
            disabled: () =>
              !this.helper.tienePermiso(
                'Administración - Editar dispositivos Lorawan',
              ),
          },
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: () =>
              !this.helper.tienePermiso(
                'Administración - Eliminar dispositivos Lorawan',
              ),
          },
          // ── Network Server (ChirpStack) ──
          {
            tipo: 'material',
            icon: 'dns',
            tooltip: 'Network Server',
            children: [
              {
                tipo: 'material',
                icon: 'search',
                tooltip: 'Consultar en Network Server',
                click: (dato) => this.consultarDeviceChirpstack(dato),
                disabled: () =>
                  !this.helper.tienePermiso(
                    'Administración - Ver dispositivos Lorawan',
                  ),
              },
              {
                tipo: 'material',
                icon: 'add',
                tooltip: 'Crear en Network Server',
                click: (dato) => this.crearChirpstack(dato),
                disabled: () =>
                  !this.helper.tienePermiso(
                    'Administración - Crear dispositivos Lorawan',
                  ),
              },
              {
                tipo: 'material',
                color: 'warn',
                icon: 'delete',
                tooltip: 'Eliminar en Network Server',
                click: (dato) => this.eliminarChirpstack(dato),
                disabled: () =>
                  !this.helper.tienePermiso(
                    'Administración - Eliminar dispositivos Lorawan',
                  ),
              },
            ],
          },
        ],
      },
    });
    this.columnas = columnas;
  }

  // Devuelve la frecuencia de reporte (minutos) según el tipo de dispositivo
  private getFrecuenciaReporte(dato: IDispositivoLorawan): number | null {
    if (!dato) return null;
    if (dato.tipo === 'Luminaria Wellness') return 15;
    if (dato.tipo === 'Luminaria GPE') {
      const cfg = (dato.config as IDispositivoLuminariaGPE)?.configGeneral;
      return cfg?.frecReporte ?? null;
    }
    if (dato.tipo === 'Luminaria ACTIS FING') {
      const cfg = (dato.config as IDispositivoLuminariaACTIS)?.configReportes;
      return cfg?.periodoEnergia ?? cfg?.periodoEstado ?? null;
    }
    return null;
  }

  // Hooks

  async ngOnInit() {
    // Se re-evalúa acá además del inicializador del campo: `esNivel0` sale de
    // un signal que se puebla al cargar los permisos, y el constructor puede
    // correr antes de eso (quedaría el botón escondido para un nivel 0).
    this.botonesHeader[0].mostrar = this.helper.esNivel0();

    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }
    this.setColumnas();
    await this.listar();
  }

  ngOnDestroy() {
    this.dispositivosLorawan$?.unsubscribe();
  }
}
